import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Example from "./Example";

const App = () => {
  return (
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/example" element={<Example />}></Route>
      </Routes>
  );
};

export default App;